export const DEFAULT_IMAGE_URL = process.env.REACT_APP_CLOUDINARY_DEFAULT_IMAGE || 
  'https://res.cloudinary.com/YOUR_CLOUD_NAME/image/upload/v1/linkforest/defaults/noImage.png';

export const isFirebaseStorageUrl = (url) => {
  return url && url.includes('firebasestorage.googleapis.com');
};
